import React, { useState } from "react";
import { flexRender } from "@tanstack/react-table";
import { Button, Dropdown } from "react-bootstrap";
import { FaFilter } from "react-icons/fa";
import FilterCell from "../filters/FilterCell";

export default function TableHeader({ table }) {
  const [openDropdownId, setOpenDropdownId] = useState(null);

  return (
    <thead>
      {table.getHeaderGroups().map((headerGroup) => (
        <tr key={headerGroup.id}>
          {headerGroup.headers.map((header) => (
            <th
              key={header.id}
              onClick={header.column.getToggleSortingHandler()}
              style={{
                padding: "6px 8px",
                textAlign: "left",
                cursor: "pointer",
                fontWeight: "500",
                color: "#333",
                background: "#f9f9f9",
                borderBottom: "2px solid #e0e0e0",
              }}
            >
              <div style={{ position: "relative" }}>
                <div className="d-flex align-items-center gap-1">
                  {/* Column title */}
                  {flexRender(
                    header.column.columnDef.header,
                    header.getContext(),
                  )}

                  {/* Sort icon */}
                  <span style={{ color: "#999" }}>
                    {{ asc: "↑", desc: "↓" }[header.column.getIsSorted()] ??
                      null}
                  </span>

                  {/* Filter dropdown */}
                  {header.column.getCanFilter() && (
                    <Dropdown
                      show={openDropdownId === header.id}
                      onToggle={(isOpen) => {
                        setOpenDropdownId(isOpen ? header.id : null);
                      }}
                      onClick={(e) => e.stopPropagation()}
                      style={{ marginLeft: "auto", paddingRight: "12px" }}
                    >
                      <Dropdown.Toggle as="span" style={{ cursor: "pointer" }}>
                        <Button variant="light" size="sm">
                          <FaFilter
                            size={12}
                            style={{
                              color: header.column.getFilterValue()
                                ? "#0E91C6"
                                : "#999",
                            }}
                          />
                        </Button>
                      </Dropdown.Toggle>

                      <Dropdown.Menu
                        style={{
                          minWidth: "250px",
                          padding: "0.5rem",
                          maxHeight: "400px",
                          overflowY: "auto",
                        }}
                      >
                        <FilterCell
                          column={header.column}
                          onFilterChange={(value) =>
                            header.column.setFilterValue(value)
                          }
                        />
                      </Dropdown.Menu>
                    </Dropdown>
                  )}

                  {/* Column separator */}
                  {header.index !== headerGroup.headers.length - 1 && (
                    <div
                      style={{
                        position: "absolute",
                        right: 0,
                        top: "25%",
                        height: "70%",
                        width: "2px",
                        background: "#e0e0e0",
                      }}
                    />
                  )}
                </div>
              </div>
            </th>
          ))}
        </tr>
      ))}
    </thead>
  );
}
